import React, { useEffect, useState } from 'react';
import { galleryAPI } from '../services/api';
import { GalleryImage } from '../types';
import './Gallery.css';

const Gallery: React.FC = () => {
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await galleryAPI.getAll();
      setImages(response.data.images);
    } catch (error) {
      console.error('Galeri yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const openModal = (image: GalleryImage) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      <section className="screen screen-gallery">
        <div className="panel-content">
          <h1>Galeri</h1>
        </div>
      </section>

      <section className="screen-tail screen-tail--gallery" aria-label="Galeri içerik alanı">
        <div className="tail-container">
          {loading ? (
            <div className="gallery-loading">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          ) : images.length === 0 ? (
            <div className="gallery-empty">
              <i className="bi bi-image"></i>
              <p>Henüz galeri resmi bulunmamaktadır</p>
            </div>
          ) : (
            <div className="gallery-grid">
              {images.map((image) => (
                <div
                  key={image.id}
                  className="gallery-item"
                  onClick={() => openModal(image)}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => e.key === 'Enter' && openModal(image)}
                >
                  <div className="gallery-image-wrapper">
                    <img
                      src={`http://localhost:5000${image.image_path}`}
                      alt={image.title || 'Galeri resmi'}
                      className="gallery-image"
                      loading="lazy"
                    />
                    <div className="gallery-overlay">
                      <i className="bi bi-zoom-in"></i>
                    </div>
                  </div>
                  <div className="gallery-info">
                    <h3 className="gallery-title">{image.title || 'Başlıksız'}</h3>
                    {image.description && (
                      <p className="gallery-description">{image.description}</p>
                    )}
                    <div className="gallery-meta">
                      <span className="gallery-date">
                        <i className="bi bi-calendar3"></i>
                        {formatDate(image.created_at)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Modal - Resim Büyütme */}
      {selectedImage && (
        <div
          className="gallery-modal"
          onClick={handleBackdropClick}
          role="dialog"
          aria-modal="true"
        >
          <div className="gallery-modal-content">
            <button
              className="gallery-modal-close"
              onClick={closeModal}
              aria-label="Kapat"
            >
              <i className="bi bi-x-lg"></i>
            </button>
            <img
              src={`http://localhost:5000${selectedImage.image_path}`}
              alt={selectedImage.title || 'Galeri resmi'}
              className="gallery-modal-image"
            />
            <div className="gallery-modal-info">
              <h2>{selectedImage.title || 'Başlıksız'}</h2>
              {selectedImage.description && <p>{selectedImage.description}</p>}
              <div className="gallery-modal-meta">
                <span>
                  <i className="bi bi-calendar3"></i>
                  {formatDate(selectedImage.created_at)}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
